import { __decorate } from "tslib";
import { module } from 'angular';
import { NgModule } from 'angular-ts-decorators';
import ngInfiniteScroll from 'ng-infinite-scroll';
import { SupportDesignModule } from 'src/Foundation/Design/app';
import { SharedModule } from 'src/shared';
import { PfmPagerComponent } from './pfm-pager/pfm-pager.component';
import { ProductFilterGroupComponent } from './product-filter-group/product-filter-group.component';
import { ProductItemLabelsComponent } from './product-item-labels/product-item-labels.component';
import { ProductItemSkuComponent } from './product-item-sku/product-item-sku.component';
import { ProductItemComponent } from './product-item/product-item.component';
import { ProductItemFeatures } from './product-item-features/product-item-features.component';
import { ProductOrdersComponent } from './product-orders/product-orders.component';
import { PfmController } from './product-filter-module-spot/product-filter-module-spot.controller';
import { ProductReadMoreDirective } from './directives/product-read-more.directive';
import { ProductToolbarStickyDirective } from './directives/product-toolbar-sticky.directive';
import { PfmLoadQueueService, PfmUrlHelperService } from './services';
import { ProductFilterModuleApiService } from './services/product-filter-module-api.service';
var moduleId = 'gn.audio.support.product-finder';
var legacyModuleId = moduleId + ".legacy";
module(legacyModuleId, [])
    .controller('PfmController', PfmController);
var ProductFinderModule = (function () {
    function ProductFinderModule() {
    }
    ProductFinderModule = __decorate([
        NgModule({
            declarations: [
                PfmPagerComponent,
                ProductFilterGroupComponent,
                ProductItemComponent,
                ProductItemLabelsComponent,
                ProductItemSkuComponent,
                ProductItemFeatures,
                ProductOrdersComponent,
                ProductReadMoreDirective,
                ProductToolbarStickyDirective,
            ],
            id: moduleId,
            imports: [
                ngInfiniteScroll,
                legacyModuleId,
                SupportDesignModule,
                SharedModule,
            ],
            providers: [
                PfmLoadQueueService,
                PfmUrlHelperService,
                ProductFilterModuleApiService,
            ]
        })
    ], ProductFinderModule);
    return ProductFinderModule;
}());
export { ProductFinderModule };
module('infinite-scroll')
    .value('THROTTLE_MILLISECONDS', 250);
